"use strict";

var _regeneratorRuntime = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Graph = exports.GraphEdgeCollection = exports.GraphVertexCollection = void 0;
/**
 * ```ts
 * import type {
 *   Graph,
 *   GraphVertexCollection,
 *   GraphEdgeCollection,
 * } from "arangojs/graph";
 * ```
 *
 * The "graph" module provides graph related types and interfaces
 * for TypeScript.
 *
 * @packageDocumentation
 */

var collection_1 = require("./collection");

var documents_1 = require("./documents");

var error_1 = require("./error");

var codes_1 = require("./lib/codes");
/**
 * @internal
 * @hidden
 */


function mungeGharialResponse(body, prop) {
  var newDoc = body.new,
      oldDoc = body.old,
      doc = body[prop],
      meta = _objectWithoutProperties(body, ["new", "old", prop].map(_toPropertyKey));

  var result = _objectSpread(_objectSpread({}, meta), doc);

  if (typeof newDoc !== "undefined") result.new = newDoc;
  if (typeof oldDoc !== "undefined") result.old = oldDoc;
  return result;
}
/**
 * @internal
 * @hidden
 */


function coerceEdgeDefinition(options) {
  var edgeDefinition = {};
  edgeDefinition.collection = collection_1.collectionToString(options.collection);
  edgeDefinition.from = Array.isArray(options.from) ? options.from.map(collection_1.collectionToString) : [collection_1.collectionToString(options.from)];
  edgeDefinition.to = Array.isArray(options.to) ? options.to.map(collection_1.collectionToString) : [collection_1.collectionToString(options.to)];
  return edgeDefinition;
}
/**
 * Represents a {@link DocumentCollection} of vertices in a {@link Graph}.
 *
 * @param T - Type to use for document data. Defaults to `any`.
 */


var GraphVertexCollection = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function GraphVertexCollection(db, name, graph) {
    _classCallCheck(this, GraphVertexCollection);

    this._db = db;
    this._name = name;
    this._graph = graph;
    this._collection = db.collection(name);
  }
  /**
   * @internal
   *
   * Indicates that this object represents an ArangoDB collection.
   */


  _createClass(GraphVertexCollection, [{
    key: "isArangoCollection",
    get: function get() {
      return true;
    }
    /**
     * Name of the collection.
     */

  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * A {@link DocumentCollection} instance for this vertex collection.
     */

  }, {
    key: "collection",
    get: function get() {
      return this._collection;
    }
    /**
     * The {@link Graph} instance this vertex collection is bound to.
     */

  }, {
    key: "graph",
    get: function get() {
      return this._graph;
    }
    /**
     * Checks whether a vertex matching the given key or id exists in this
     * collection.
     *
     * Throws an exception when passed a vertex or `_id` from a different
     * collection.
     *
     * @param selector - Document `_key`, `_id` or object with either of those
     * properties (e.g. a vertex from this collection).
     *
     * @example
     * ```js
     * const graph = db.graph("some-graph");
     * const collection = graph.vertexCollection("vertices");
     * const exists = await collection.vertexExists("abc123");
     * if (!exists) {
     *   console.log("Vertex does not exist");
     * }
     * ```
     */

  }, {
    key: "vertexExists",
    value: function () {
      var _vertexExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(selector) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this._db.request({
                  method: "HEAD",
                  path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(documents_1._documentHandle(selector, this._name))
                }, function () {
                  return true;
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (!(_context.t0.code === 404)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                throw _context.t0;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function vertexExists(_x) {
        return _vertexExists.apply(this, arguments);
      }

      return vertexExists;
    }()
  }, {
    key: "vertex",
    value: function () {
      var _vertex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selector) {
        var options,
            _options,
            _options$allowDirtyRe,
            allowDirtyRead,
            _options$graceful,
            graceful,
            rev,
            qs,
            headers,
            result,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (typeof options === "boolean") {
                  options = {
                    graceful: options
                  };
                }

                _options = options, _options$allowDirtyRe = _options.allowDirtyRead, allowDirtyRead = _options$allowDirtyRe === void 0 ? undefined : _options$allowDirtyRe, _options$graceful = _options.graceful, graceful = _options$graceful === void 0 ? false : _options$graceful, rev = _options.rev, qs = _objectWithoutProperties(_options, ["allowDirtyRead", "graceful", "rev"]);
                headers = {};
                if (rev) headers["if-match"] = rev;
                result = this._db.request({
                  path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(documents_1._documentHandle(selector, this._name)),
                  headers: headers,
                  qs: qs,
                  allowDirtyRead: allowDirtyRead
                }, function (res) {
                  return res.body.vertex;
                });

                if (graceful) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", result);

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return result;

              case 11:
                return _context2.abrupt("return", _context2.sent);

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](8);

                if (!(error_1.isArangoError(_context2.t0) && _context2.t0.errorNum === codes_1.DOCUMENT_NOT_FOUND)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", null);

              case 18:
                throw _context2.t0;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 14]]);
      }));

      function vertex(_x2) {
        return _vertex.apply(this, arguments);
      }

      return vertex;
    }()
  }, {
    key: "save",
    value: function save(data, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(this._name),
        body: data,
        qs: options
      }, function (res) {
        return mungeGharialResponse(res.body, "vertex");
      });
    }
  }, {
    key: "replace",
    value: function replace(selector, newValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var _options2 = options,
          rev = _options2.rev,
          qs = _objectWithoutProperties(_options2, ["rev"]);

      var headers = {};
      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "PUT",
        path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(documents_1._documentHandle(selector, this._name)),
        body: newValue,
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "vertex");
      });
    }
  }, {
    key: "update",
    value: function update(selector, newValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var headers = {};

      var _options3 = options,
          rev = _options3.rev,
          qs = _objectWithoutProperties(_options3, ["rev"]);

      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "PATCH",
        path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(documents_1._documentHandle(selector, this._name)),
        body: newValue,
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "vertex");
      });
    }
  }, {
    key: "remove",
    value: function remove(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var headers = {};

      var _options4 = options,
          rev = _options4.rev,
          qs = _objectWithoutProperties(_options4, ["rev"]);

      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "DELETE",
        path: "/_api/gharial/".concat(this.graph.name, "/vertex/").concat(documents_1._documentHandle(selector, this._name)),
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "removed");
      });
    }
  }]);

  return GraphVertexCollection;
}();

exports.GraphVertexCollection = GraphVertexCollection;
/**
 * Represents a {@link EdgeCollection} of edges in a {@link Graph}.
 *
 * @param T - Type to use for document data. Defaults to `any`.
 */

var GraphEdgeCollection = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function GraphEdgeCollection(db, name, graph) {
    _classCallCheck(this, GraphEdgeCollection);

    this._db = db;
    this._name = name;
    this._graph = graph;
    this._collection = db.collection(name);
  }
  /**
   * @internal
   *
   * Indicates that this object represents an ArangoDB collection.
   */


  _createClass(GraphEdgeCollection, [{
    key: "isArangoCollection",
    get: function get() {
      return true;
    }
    /**
     * Name of the collection.
     */

  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * A {@link EdgeCollection} instance for this edge collection.
     */

  }, {
    key: "collection",
    get: function get() {
      return this._collection;
    }
    /**
     * The {@link Graph} instance this edge collection is bound to.
     */

  }, {
    key: "graph",
    get: function get() {
      return this._graph;
    }
    /**
     * Checks whether a edge matching the given key or id exists in this
     * collection.
     *
     * Throws an exception when passed a edge or `_id` from a different
     * collection.
     *
     * @param selector - Document `_key`, `_id` or object with either of those
     * properties (e.g. a edge from this collection).
     *
     * @example
     * ```js
     * const graph = db.graph("some-graph");
     * const collection = graph.edgeCollection("friends")
     * const exists = await collection.edgeExists("abc123");
     * if (!exists) {
     *   console.log("Edge does not exist");
     * }
     * ```
     */

  }, {
    key: "edgeExists",
    value: function () {
      var _edgeExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(selector) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this._db.request({
                  method: "HEAD",
                  path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(documents_1._documentHandle(selector, this._name))
                }, function () {
                  return true;
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);

                if (!(_context3.t0.code === 404)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", false);

              case 10:
                throw _context3.t0;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function edgeExists(_x3) {
        return _edgeExists.apply(this, arguments);
      }

      return edgeExists;
    }()
  }, {
    key: "edge",
    value: function () {
      var _edge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(selector) {
        var options,
            _options5,
            _options5$allowDirtyR,
            allowDirtyRead,
            _options5$graceful,
            graceful,
            rev,
            qs,
            headers,
            result,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (typeof options === "boolean") {
                  options = {
                    graceful: options
                  };
                }

                _options5 = options, _options5$allowDirtyR = _options5.allowDirtyRead, allowDirtyRead = _options5$allowDirtyR === void 0 ? undefined : _options5$allowDirtyR, _options5$graceful = _options5.graceful, graceful = _options5$graceful === void 0 ? false : _options5$graceful, rev = _options5.rev, qs = _objectWithoutProperties(_options5, ["allowDirtyRead", "graceful", "rev"]);
                headers = {};
                if (rev) headers["if-match"] = rev;
                result = this._db.request({
                  path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(documents_1._documentHandle(selector, this._name)),
                  qs: qs,
                  allowDirtyRead: allowDirtyRead
                }, function (res) {
                  return res.body.edge;
                });

                if (graceful) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", result);

              case 8:
                _context4.prev = 8;
                _context4.next = 11;
                return result;

              case 11:
                return _context4.abrupt("return", _context4.sent);

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](8);

                if (!(error_1.isArangoError(_context4.t0) && _context4.t0.errorNum === codes_1.DOCUMENT_NOT_FOUND)) {
                  _context4.next = 18;
                  break;
                }

                return _context4.abrupt("return", null);

              case 18:
                throw _context4.t0;

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 14]]);
      }));

      function edge(_x4) {
        return _edge.apply(this, arguments);
      }

      return edge;
    }()
  }, {
    key: "save",
    value: function save(data, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(this._name),
        body: data,
        qs: options
      }, function (res) {
        return mungeGharialResponse(res.body, "edge");
      });
    }
  }, {
    key: "replace",
    value: function replace(selector, newValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var _options6 = options,
          rev = _options6.rev,
          qs = _objectWithoutProperties(_options6, ["rev"]);

      var headers = {};
      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "PUT",
        path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(documents_1._documentHandle(selector, this._name)),
        body: newValue,
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "edge");
      });
    }
  }, {
    key: "update",
    value: function update(selector, newValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var _options7 = options,
          rev = _options7.rev,
          qs = _objectWithoutProperties(_options7, ["rev"]);

      var headers = {};
      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "PATCH",
        path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(documents_1._documentHandle(selector, this._name)),
        body: newValue,
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "edge");
      });
    }
  }, {
    key: "remove",
    value: function remove(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof options === "string") {
        options = {
          rev: options
        };
      }

      var _options8 = options,
          rev = _options8.rev,
          qs = _objectWithoutProperties(_options8, ["rev"]);

      var headers = {};
      if (rev) headers["if-match"] = rev;
      return this._db.request({
        method: "DELETE",
        path: "/_api/gharial/".concat(this.graph.name, "/edge/").concat(documents_1._documentHandle(selector, this._name)),
        qs: qs,
        headers: headers
      }, function (res) {
        return mungeGharialResponse(res.body, "removed");
      });
    }
  }]);

  return GraphEdgeCollection;
}();

exports.GraphEdgeCollection = GraphEdgeCollection;
/**
 * Represents a graph in a {@link Database}.
 */

var Graph = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function Graph(db, name) {
    _classCallCheck(this, Graph);

    this._name = name;
    this._db = db;
  }
  /**
   * Name of the graph.
   */


  _createClass(Graph, [{
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * Checks whether the graph exists.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const result = await graph.exists();
     * // result indicates whether the graph exists
     * ```
     */

  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.get();

              case 3:
                return _context5.abrupt("return", true);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);

                if (!(error_1.isArangoError(_context5.t0) && _context5.t0.errorNum === codes_1.GRAPH_NOT_FOUND)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", false);

              case 10:
                throw _context5.t0;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 6]]);
      }));

      function exists() {
        return _exists.apply(this, arguments);
      }

      return exists;
    }()
    /**
     * Retrieves general information about the graph.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const data = await graph.get();
     * // data contains general information about the graph
     * ```
     */

  }, {
    key: "get",
    value: function get() {
      return this._db.request({
        path: "/_api/gharial/".concat(this._name)
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Creates a graph with the given `edgeDefinitions` and `options` for this
     * graph's name.
     *
     * @param edgeDefinitions - Definitions for the relations of the graph.
     * @param options - Options for creating the graph.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * // graph now exists
     * ```
     */

  }, {
    key: "create",
    value: function create(edgeDefinitions, options) {
      var _ref = options || {},
          orphanCollections = _ref.orphanCollections,
          waitForSync = _ref.waitForSync,
          isSmart = _ref.isSmart,
          isDisjoint = _ref.isDisjoint,
          opts = _objectWithoutProperties(_ref, ["orphanCollections", "waitForSync", "isSmart", "isDisjoint"]);

      return this._db.request({
        method: "POST",
        path: "/_api/gharial",
        body: {
          orphanCollections: orphanCollections && (Array.isArray(orphanCollections) ? orphanCollections.map(collection_1.collectionToString) : [collection_1.collectionToString(orphanCollections)]),
          edgeDefinitions: edgeDefinitions.map(coerceEdgeDefinition),
          isSmart: isSmart,
          isDisjoint: isDisjoint,
          name: this._name,
          options: opts
        },
        qs: {
          waitForSync: waitForSync
        }
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Deletes the graph from the database.
     *
     * @param dropCollections - If set to `true`, the collections associated with
     * the graph will also be deleted.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * await graph.drop();
     * // the graph "some-graph" no longer exists
     * ```
     */

  }, {
    key: "drop",
    value: function drop() {
      var dropCollections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._db.request({
        method: "DELETE",
        path: "/_api/gharial/".concat(this._name),
        qs: {
          dropCollections: dropCollections
        }
      }, function (res) {
        return res.body.removed;
      });
    }
    /**
     * Returns a {@link GraphVertexCollection} instance for the given collection
     * name representing the collection in this graph.
     *
     * @param T - Type to use for document data. Defaults to `any`.
     * @param collection - Name of the vertex collection.
     */

  }, {
    key: "vertexCollection",
    value: function vertexCollection(collection) {
      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return new GraphVertexCollection(this._db, collection, this);
    }
    /**
     * Fetches all vertex collections of this graph from the database and returns
     * an array of their names.
     *
     * See also {@link Graph.vertexCollections}.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * const vertexCollectionNames = await graph.listVertexCollections();
     * // ["start-vertices", "end-vertices"]
     * ```
     */

  }, {
    key: "listVertexCollections",
    value: function listVertexCollections() {
      return this._db.request({
        path: "/_api/gharial/".concat(this._name, "/vertex")
      }, function (res) {
        return res.body.collections;
      });
    }
    /**
     * Fetches all vertex collections of this graph from the database and returns
     * an array of {@link GraphVertexCollection} instances.
     *
     * See also {@link Graph.listVertexCollections}.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * const vertexCollections = await graph.vertexCollections();
     * for (const vertexCollection of vertexCollections) {
     *   console.log(vertexCollection.name);
     *   // "start-vertices"
     *   // "end-vertices"
     * }
     * ```
     */

  }, {
    key: "vertexCollections",
    value: function () {
      var _vertexCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this = this;

        var names;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.listVertexCollections();

              case 2:
                names = _context6.sent;
                return _context6.abrupt("return", names.map(function (name) {
                  return new GraphVertexCollection(_this._db, name, _this);
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function vertexCollections() {
        return _vertexCollections.apply(this, arguments);
      }

      return vertexCollections;
    }()
    /**
     * Adds the given collection to this graph as a vertex collection.
     *
     * @param collection - Collection to add to the graph.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * await graph.addVertexCollection("more-vertices");
     * // The collection "more-vertices" has been added to the graph
     * const extra = db.collection("extra-vertices");
     * await graph.addVertexCollection(extra);
     * // The collection "extra-vertices" has been added to the graph
     * ```
     */

  }, {
    key: "addVertexCollection",
    value: function addVertexCollection(collection) {
      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return this._db.request({
        method: "POST",
        path: "/_api/gharial/".concat(this._name, "/vertex"),
        body: {
          collection: collection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Removes the given collection from this graph as a vertex collection.
     *
     * @param collection - Collection to remove from the graph.
     * @param dropCollection - If set to `true`, the collection will also be
     * deleted from the database.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * await graph.removeVertexCollection("start-vertices");
     * // The collection "start-vertices" is no longer part of the graph.
     * ```
     */

  }, {
    key: "removeVertexCollection",
    value: function removeVertexCollection(collection) {
      var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return this._db.request({
        method: "DELETE",
        path: "/_api/gharial/".concat(this._name, "/vertex/").concat(collection),
        qs: {
          dropCollection: dropCollection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Returns a {@link GraphEdgeCollection} instance for the given collection
     * name representing the collection in this graph.
     *
     * @param T - Type to use for document data. Defaults to `any`.
     * @param collection - Name of the edge collection.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * const graphEdgeCollection = graph.edgeCollection("edges");
     * // Access the underlying EdgeCollection API:
     * const edgeCollection = graphEdgeCollection.collection;
     * ```
     */

  }, {
    key: "edgeCollection",
    value: function edgeCollection(collection) {
      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return new GraphEdgeCollection(this._db, collection, this);
    }
    /**
     * Fetches all edge collections of this graph from the database and returns
     * an array of their names.
     *
     * See also {@link Graph.edgeCollections}.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * const edgeCollectionNames = await graph.listEdgeCollections();
     * // ["edges"]
     * ```
     */

  }, {
    key: "listEdgeCollections",
    value: function listEdgeCollections() {
      return this._db.request({
        path: "/_api/gharial/".concat(this._name, "/edge")
      }, function (res) {
        return res.body.collections;
      });
    }
    /**
     * Fetches all edge collections of this graph from the database and returns
     * an array of {@link GraphEdgeCollection} instances.
     *
     * See also {@link Graph.listEdgeCollections}.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * const graphEdgeCollections = await graph.edgeCollections();
     * for (const collection of graphEdgeCollection) {
     *   console.log(collection.name);
     *   // "edges"
     * }
     * ```
     */

  }, {
    key: "edgeCollections",
    value: function () {
      var _edgeCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;

        var names;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.listEdgeCollections();

              case 2:
                names = _context7.sent;
                return _context7.abrupt("return", names.map(function (name) {
                  return new GraphEdgeCollection(_this2._db, name, _this2);
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function edgeCollections() {
        return _edgeCollections.apply(this, arguments);
      }

      return edgeCollections;
    }()
    /**
     * Adds an edge definition to this graph.
     *
     * @param edgeDefinition - Definition of a relation in this graph.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * await graph.addEdgeDefinition({
     *   collection: "edges",
     *   from: ["start-vertices"],
     *   to: ["end-vertices"],
     * });
     * // The edge definition has been added to the graph
     * ```
     */

  }, {
    key: "addEdgeDefinition",
    value: function addEdgeDefinition(edgeDefinition) {
      return this._db.request({
        method: "POST",
        path: "/_api/gharial/".concat(this._name, "/edge"),
        body: coerceEdgeDefinition(edgeDefinition)
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "replaceEdgeDefinition",
    value: function replaceEdgeDefinition(collection, edgeDefinition) {
      if (!edgeDefinition) {
        edgeDefinition = collection;
        collection = edgeDefinition.collection;
      }

      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return this._db.request({
        method: "PUT",
        path: "/_api/gharial/".concat(this._name, "/edge/").concat(collection),
        body: coerceEdgeDefinition(edgeDefinition)
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Removes the edge definition for the given edge collection from this graph.
     *
     * @param collection - Edge collection for which to remove the definition.
     * @param dropCollection - If set to `true`, the collection will also be
     * deleted from the database.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("some-graph");
     * const info = await graph.create([
     *   {
     *     collection: "edges",
     *     from: ["start-vertices"],
     *     to: ["end-vertices"],
     *   },
     * ]);
     * await graph.removeEdgeDefinition("edges");
     * // The edge definition for "edges" has been replaced
     * ```
     */

  }, {
    key: "removeEdgeDefinition",
    value: function removeEdgeDefinition(collection) {
      var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (collection_1.isArangoCollection(collection)) {
        collection = collection.name;
      }

      return this._db.request({
        method: "DELETE",
        path: "/_api/gharial/".concat(this._name, "/edge/").concat(collection),
        qs: {
          dropCollection: dropCollection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
    /**
     * Performs a traversal starting from the given `startVertex` and following
     * edges contained in this graph.
     *
     * See also {@link EdgeCollection.traversal}.
     *
     * @param startVertex - Document `_id` of a vertex in this graph.
     * @param options - Options for performing the traversal.
     *
     * @deprecated Simple Queries have been deprecated in ArangoDB 3.4 and can be
     * replaced with AQL queries.
     *
     * @example
     * ```js
     * const db = new Database();
     * const graph = db.graph("my-graph");
     * const collection = graph.edgeCollection("edges").collection;
     * await collection.import([
     *   ["_key", "_from", "_to"],
     *   ["x", "vertices/a", "vertices/b"],
     *   ["y", "vertices/b", "vertices/c"],
     *   ["z", "vertices/c", "vertices/d"],
     * ]);
     * const result = await graph.traversal("vertices/a", {
     *   direction: "outbound",
     *   init: "result.vertices = [];",
     *   visitor: "result.vertices.push(vertex._key);",
     * });
     * console.log(result.vertices); // ["a", "b", "c", "d"]
     * ```
     */

  }, {
    key: "traversal",
    value: function traversal(startVertex, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/traversal",
        body: _objectSpread(_objectSpread({}, options), {}, {
          startVertex: startVertex,
          graphName: this._name
        })
      }, function (res) {
        return res.body.result;
      });
    }
  }]);

  return Graph;
}();

exports.Graph = Graph;